export default __webpack_public_path__ + "static/media/wh-2.3ec2037d.png";